import type { LegacyHistory as History } from '@/hooks/useUrlState';

/** Merge query-param updates on the current path (replaces legacy broken pathname branch). */
export const mergeSearchParams = (
  history: History,
  add?: { [key: string]: string },
  remove?: string[],
) => {
  const params = new URLSearchParams(history.location.search);
  if (add) {
    Object.keys(add).forEach((key) => params.set(key, add[key]));
  }
  if (remove) {
    remove.forEach((key) => params.delete(key));
  }
  const search = params.toString();
  history.push({
    pathname: history.location.pathname,
    search: search ? `?${search}` : '',
  });
};

export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
